import React from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Process from '../components/Process';
import WhyUs from '../components/WhyUs';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navigation />
      <Hero />
      <Services />
      <Process />
      <WhyUs />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
